<template>
  <div class="main-loader">
    <font-awesome-icon icon="spinner" pulse />
  </div>
</template>

<script>
export default {
  name: "Loader",
};
</script>
